import { render, staticRenderFns } from "./Transferencia.vue?vue&type=template&id=65abbfe8&scoped=true&"
import script from "./Transferencia.vue?vue&type=script&lang=js&"
export * from "./Transferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abbfe8",
  null
  
)

export default component.exports